import { GetterTree } from "vuex";
import { IUiState } from "./types";
import { IRootState } from "@/store/types";

export namespace UI_GETTERS {
  export const IS_LOADING = "isLoading";
}

export const getters: GetterTree<IUiState, IRootState> = {
  [UI_GETTERS.IS_LOADING]: (state: IUiState) => state.isLoading
};
